module.exports = __webpack_public_path__ + "media/images/features/modification/thumb-voices-3-cd2a193235f8eea780bbfbd64dd1590d.png";